// @flow
import * as React from "react";
import styled, { css } from "styled-components";
import idx from "idx";
import Media from "react-media";
import Money from "../../../Money";
import Gettext from "../../../common/Gettext";
import SimpleSpinner from "../../../Spinners/SimpleSpinner";

import { ColorfulCup } from "../../../Icons/Tournaments";
import HowMuchInBucks from "../../../HowMuchInBucks";
import { tournamentCurrency } from "../../../Icons/Kuchka";
import { rgba } from "polished";

import * as S from "./styles";

import type { Tournament as TournamentProps } from "../../../../redux/CommonTypes";

const SpinnerContainer = styled.div`
  flex: 1;
  padding: 16px;
  text-align: center;
`;

const Container = styled.div`
  flex-grow: 1;
  flex-shrink: 0;

  @media (min-height: 960px) {
    padding: 15px 25px;
  }
`;

const Grid = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: space-between;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 959px) {
    font-size: 12px;
  }

  & > div {
    flex: 3.5;
    min-width: 70px;
  }

  & > div:nth-of-type(2) {
    padding: 0 10px;
  }

  & > div:first-of-type {
    flex: 1;

    @media(max-width: 959px) {
      flex: 0.5;
      min-width: 50px;
    }

    ${({ theme }) => {
      if (theme.direction === "rtl")
        return css`
          text-align: right;
        `;

      return css`
        text-align: left;
      `;
    }};
  }

  & > div:last-of-type {
    flex: 1;

    ${({ theme }) => {
      if (theme.direction === "rtl")
        return css`
          text-align: left;
        `;

      return css`
        text-align: right;
      `;
    }};
  }
}

  ${
    "" /* @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 3.5fr) 1fr;
    grid-gap: 15px;

    @media (max-width: 959px) {
      grid-template-columns: 0.5fr minmax(min-content, 3.5fr) 1fr;
      grid-gap: 10px;
    }

    & > div:first-of-type {
      ${({ theme }) => {
        if (theme.direction === "rtl")
          return css`
            text-align: right;
          `;

        return css`
          text-align: left;
        `;
      }};
    }

    & > div:last-of-type {
      ${({ theme }) => {
        if (theme.direction === "rtl")
          return css`
            text-align: left;
          `;

        return css`
          text-align: right;
        `;
      }};
    }
  } */
  };
`;

const WinnerHeader = styled(Grid)`
  padding: 5px 15px;
  font-size: 10px;
  color: #99959d;

  @media (max-width: 959px) {
    font-size: 10px;
  }
`;

const WinnerContents = styled(Grid)`
  padding: 15px;
  background-color: ${({ theme }) => theme.mainLight};
`;

const WinnerPlace = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.accent};
`;

const WinnerReward = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-content: center;
  font-size: 18px;

  @media (min-width: 960px) {
    font-size: 32px;
    text-align: center;
  }
`;

const RatingRowGrid = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: space-between;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 959px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "12px"};
  }
`;

const RatingHeader = styled(RatingRowGrid)`
  padding: 5px 15px;
  font-size: 10px;
  color: #99959d;

  @media (max-width: 959px) {
    font-size: ${({ theme }) =>
      theme.locale === "ar" ? theme.minFontSize : "10px"};
  }
`;

const RatingContents = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  align-content: space-between;
  justify-content: space-between;
`;

const RatingRow = styled(RatingRowGrid)`
  position: relative;
  min-height: 32px;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.mainLight};
  opacity: 0.9;

  :not(:last-of-type) {
    margin-bottom: 4px;
  }

  ${({ current, theme }) =>
    current === true &&
    css`
      min-height: 44px;
      color: ${theme.accent};
      opacity: 1;
    `};
`;

const RatingNumber = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: 34px;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        margin-left: 8px;
        text-align: right;
      `;

    return css`
      margin-right: 8px;
      text-align: left;
    `;
  }};
`;

const RatingName = styled.div`
  flex: 3;
  display: flex;
  flex-flow: row nowrap;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        margin-left: auto;
      `;

    return css`
      margin-right: auto;
    `;
  }};
`;

const RatingNameContents = styled.div`
  display: flex;
  flex-flow: row nowrap;
  color: ${({ current, theme }) => (current ? theme.accent : rgba(theme.foreground, 0.5))};
`;

const RatingID = styled.div`
  flex: 0;
  flex-basis: 70px;
  min-width: 70px;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        text-align: right;
        padding-left: 8px;
      `;

    return css`
      padding-right: 8px;
      text-align: left;
    `;
  }};
`;

const RatingBalance = styled.div`
  flex: 1;
  text-align: center;
`;

const RatingReward = styled.div`
  flex: 2;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        text-align: left;
        padding-right: 8px;
      `;

    return css`
      padding-left: 8px;
      text-align: right;
    `;
  }};
`;

const Minus = styled.div`
  width: 14px;
  height: 2px;
  background-color: #99959d;

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        margin-right: auto;
      `;

    return css`
      margin-left: auto;
    `;
  }};
`;

const Arrow = styled.svg`
  position: absolute;
  top: 50%;
  fill: ${({ theme }) => theme.accent};

  ${({ theme }) => {
    if (theme.direction === "rtl")
      return css`
        transform: translateY(-50%) rotate(180deg);
        right: -15px;
      `;

    return css`
      transform: translateY(-50%);
      left: -15px;
    `;
  }};
`;

type RewardProps = {|
  prize: string,
  prize_usd: string
|};

function Reward({ prize, prize_usd }: RewardProps) {
  return (
    <Media query="(min-width: 960px)">
      {matches =>
        matches ? (
          <HowMuchInBucks
            value={prize || "0.00"}
            valueUSD={prize_usd || "0.00"}
            symbolStyle={S.Currency}
            valueStyle={S.Value}
          />
        ) : (
          <Money currency="USD" Symbol={S.Currency} Value={S.Value}>
            {prize_usd || "0.00"}
          </Money>
        )
      }
    </Media>
  );
}

type WinnerProps = {|
  ...RewardProps,
  place: number,
  funds_available: string
|};

type ItemProps = {|
  ...WinnerProps,
  user_id: number,
  user_name: string
|};

type RowProps = {
  ...ItemProps,
  current_place: number
};

function ItemRow({
  place,
  user_id,
  user_name,
  funds_available,
  prize,
  prize_usd,
  current_place
}: RowProps) {
  const current = place === current_place;

  return (
    <RatingRow current={current}>
      {current ? (
        <Arrow
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 19.799 19.799"
          width="20px"
        >
          <path d="M14,0V14H0Z" transform="translate(0 9.9) rotate(-45)" />
        </Arrow>
      ) : null}
      <RatingNumber>{place}</RatingNumber>
      <RatingName>
        <RatingNameContents current={current}>
          <RatingID>{user_id}</RatingID>
          <Media query="(min-width: 480px)" render={() => user_name} />
        </RatingNameContents>
      </RatingName>
      <RatingBalance>
        <Money
          currency={tournamentCurrency}
          Symbol={S.Currency}
          Value={S.Value}
        >
          {funds_available}
        </Money>
      </RatingBalance>
      <RatingReward>
        {current === true || prize != null || prize_usd != null ? (
          <Reward prize={prize} prize_usd={prize_usd} />
        ) : (
          <Minus />
        )}
      </RatingReward>
    </RatingRow>
  );
}

type RatingProps = {
  children: React.Node
};

function RatingTable({ children }: RatingProps) {
  return (
    <Container>
      <RatingHeader>
        <RatingNumber>#</RatingNumber>
        <RatingName>
          <Media query="(max-width: 479px)">
            {matches =>
              matches ? <Gettext>id</Gettext> : <Gettext>id/trader</Gettext>
            }
          </Media>
        </RatingName>
        <RatingBalance>
          <Gettext>Balance</Gettext>
        </RatingBalance>
        <RatingReward>
          <Gettext>Reward</Gettext>
        </RatingReward>
      </RatingHeader>
      <RatingContents>{children}</RatingContents>
    </Container>
  );
}

function WinnerTable({
  place,
  prize,
  prize_usd,
  funds_available
}: WinnerProps) {
  return (
    <Container>
      <WinnerHeader>
        <div>#</div>
        <div style={{ textAlign: "center" }}>
          <Gettext>Reward</Gettext>
        </div>
        <div>
          <Gettext>Balance</Gettext>
        </div>
      </WinnerHeader>
      <WinnerContents>
        <WinnerPlace>{place}</WinnerPlace>
        <WinnerReward>
          <ColorfulCup width="28px" />
          &nbsp;
          <Reward prize={prize} prize_usd={prize_usd} />
        </WinnerReward>
        <div>
          <Money
            currency={tournamentCurrency}
            Symbol={S.Currency}
            Value={S.Value}
          >
            {funds_available}
          </Money>
        </div>
      </WinnerContents>
    </Container>
  );
}

const Spinner = () => (
  <SpinnerContainer>
    <SimpleSpinner accent />
  </SpinnerContainer>
);

type Props = {
  ...TournamentProps,
  winner?: boolean,
  limit: number,
  current_place: number,
  api: any
};

function Leaderboard({
  api,
  id,
  limit,
  current_place,
  participant_count,
  winner
}: Props) {
  let leaderboard = null;
  let offset = 0;

  if (id == null) {
    return null;
  }

  if (current_place != null && Number.isNaN(current_place) === false) {
    offset = current_place - 2; // запрашиваем с оффсетом -1

    switch (true) {
      case winner:
        // если юзер - победитель, запрашиваем с оффсетом 0
        offset = current_place - 1;
        break;
      case current_place === participant_count:
        // если юзер в самом конце, запрашиваем с оффсетом -2
        offset = current_place - 3;
        break;
      default:
        break;
    }

    if (offset < 0) {
      // места меньше 0 быть не может
      offset = 0;
    }
  }

  leaderboard = idx(
    api.readEntity(
      `/api/tournaments/leaderboard?tournament_id=${id}&limit=${limit}&offset=${offset}`
    ),
    leaderboard => leaderboard.value.items
  );

  if (leaderboard == null) {
    return <Spinner />;
  }

  if (winner === true) {
    return <WinnerTable {...leaderboard[0]} />;
  }

  return (
    <RatingTable>
      {leaderboard.map(item => (
        <ItemRow
          key={item.user_id + item.place}
          current_place={current_place}
          {...item}
        />
      ))}
    </RatingTable>
  );
}

export default Leaderboard;



// WEBPACK FOOTER //
// ./src/components/Tournaments/Popups/Final/Leaderboard.js